import React from "react";
import { track } from "../lib/analytics";
import { useReveal } from "../lib/useReveal";
import heroImg from "../assets/hero-founder.jpg";
import logo2 from "../assets/smartup360-logo2.png";

export default function Hero({ onOpenModal }) {
  const { ref, inView } = useReveal();

  return (
    <section className="hero hero--full" id="top" aria-label="SmartUp360 Hero">
      <div className="heroMedia" aria-hidden="true">
        <img className="heroMedia__img" src={heroImg} alt="" />
        <div className="heroMedia__overlay" />
        <div className="heroMedia__grain" />
      </div>

      <div className="container hero__inner hero__inner--full">
        <div
          className={`hero__copy hero__copy--full reveal ${
            inView ? "reveal--in" : ""
          }`}
          ref={ref}
        >
          <div className="badge badge--hero">
            <span className={`logo2 `}>
              <img src={logo2} alt="SmartUp360 icon" className="logo__img" />
            </span>

            <span className="badge__sep" aria-hidden="true" />
            <span className="muted">
              The operating system for the next generation of African Producers.
            </span>
          </div>

          <h1 className="hero__title2">From Local Excellence to Global Icon</h1>

          <p className="hero__subtitle">
            Product brilliance is only half the battle. The other half is
            <span className="hero-bold">
              {" "}
              Structure, Visibility, and Capital.
            </span>{" "}
            Leveraging 17 years of marketing authority via{" "}
            <span className="hero-bold">360 Degrees,</span> SmartUp360 is the
            exclusive high-growth engine for Nigeria’s elite{" "}
            <span className="hero-bold"> Producers</span> to institutionalize
            your business and scale your brand—at home and abroad.
          </p>

          <div className="hero__ctaRow hero__ctaRow--full">
            <a
              className="btn btn--secondary"
              href="http://waitlist.smartup360.com/"
              onClick={() => {
                track("cta_click", { source: "hero_secondary" });
              }}
            >
              Apply for the Next Global Showcase
            </a>

            <a
              className="btn btn--secondary"
              href="http://waitlist.smartup360.com/"
              onClick={() => {
                track("cta_click", { source: "hero_secondary" });
              }}
            >
              Join the 2026 Platform Waitlist
            </a>
          </div>
        </div>

        <div className="heroSide" aria-hidden="true">
          <div className="heroSide__card">
            <div className="heroSide__kicker">Lagos Born. Global Bound.</div>
            <div className="heroSide__line" />
            <div className="heroSide__stats">
              <div className="heroSide__stat">
                <div className="heroSide__statLabel">Visibility</div>
                <div className="heroSide__statValue">Global buyers</div>
              </div>
              <div className="heroSide__stat">
                <div className="heroSide__statLabel">Structure</div>
                <div className="heroSide__statValue">Operational clarity</div>
              </div>
              <div className="heroSide__stat">
                <div className="heroSide__statLabel">Capital</div>
                <div className="heroSide__statValue">Scale-ready funding</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="heroScrollHint" aria-hidden="true">
        <div className="heroScrollHint__dot" />
        <div className="heroScrollHint__text">Scroll</div>
      </div>
    </section>
  );
}
